import React from 'react'
import Tacket from './Tacket'
import Heropage from './Heropage'

function SupportPage() {
  return (
    <>
  <Heropage/>
  <Tacket/>
    </>
  )
}

export default SupportPage
